import { render, staticRenderFns } from "./InvoiceStatusDisplay.vue?vue&type=template&id=77708651&"
import script from "./InvoiceStatusDisplay.vue?vue&type=script&lang=ts&"
export * from "./InvoiceStatusDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports